import type { FaireProductEntity } from "../../entity_types/product";

export const p_ruryatepe6: FaireProductEntity = {
  token: "p_ruryatepe6",
  type: "product",
  name: "Italian Charms Acrylic Display w/ 40 Bins & Cover- Frosted ",
  brandToken: "b_kqast86cfn",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/420f630ff65a4c229fcaf33e871b4e3503ce862f1714c58c39ffb80bebea4d79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8bbbdbe5bc66806ee4a6f97f02dc879db75dc53b6d8d4fe7c67fd48479307aeb.jpeg",
    "https://cdn.faire.com/fastly/44fe71170c17a4e21daaa7cb5a8b7a0f6fdf43e2c07adb65eca1fda7233418d4.jpeg",
  ],
  priceDollars: 17.5,
  description:
    '\n * Acrylic Frosted White Heavy Duty Display Case with 40 Compartments for Organizing Charms, also Includes Sliding Cover \n * Excellent for displaying/organizing/storage of charms, jewelry, parts... \n * Made of sturdy frosted white acrylic, suitable for any flat surface or counter \n * Dimensions: 15" X 8.5" X 1.40"; Each bin-1.55" X 1.75" \n * This display case is a practical way to organize and showcase your Italian charms, dangle charms, earrings, parts and other collections. ',
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.412Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
